<template>
  <div>
    <h3>Requisições associadas a "<b>{{workflow.name}}</b>"</h3>
    <br>
    <ul class="nav nav-tabs">
      <li role="presentation" :class="'active'" class="tab">
        <a>Requisições <span class="badge">{{count}}</span></a>
      </li>
    </ul>
    <div class="tab-content">
      <div>
          <div class="row">
            <div class="col-sm-12" style="margin-top: 15px">
              <div class="panel panel-default">
                <div class="panel-heading">
                  <button class="btn btn-success btn-sm" style="margin: 10px" @click="addFilterField">
                    <span class="glyphicon glyphicon-plus"></span> Adicionar Filtro
                  </button>
                </div>
                <div class="panel-body">
                  <p class="text-muted" style="margin: 0" v-if="!fieldFilters.length">Nenhum filtro adicional aplicado.</p>
                  <div v-else v-for="(fieldFilter, index) in fieldFilters" :key="fieldFilter.field.objectId" class="row">
                    <div class="col-sm-4 form-group">
                      <multiselect id="formSelect" v-model="fieldFilter.field" label="name"
                      track-by="name" :options="formFields" placeholder="Selecione uma opção" :selectLabel="'Pressione enter'"
                      :hide-selected="true">
                      </multiselect>
                    </div>
                    <div class="col-sm-1 text-center">
                      <button disabled="disabled" class="btn btn-default">{{fieldFilter.operator}}</button>
                    </div>
                    <div class="col-sm-5 form-group">
                      <dynamic-form-field :onChange='() => {}' :formField='fieldFilter.field'></dynamic-form-field>
                    </div>
                    <div class="col-sm-1 text-center">
                      <button @click="removeFilter(index)" class="btn btn-default btn-sm btn-danger glyphicon glyphicon-trash"></button>
                    </div>
                  </div>
                </div>
                <div class="panel-footer">
                  <button @click="downloadWorkflowRequests" class="btn btn-primary btn-sm" title="Download de Todas as Requisições">
                    <span class="glyphicon glyphicon-download"></span> Download de Todas as Requisições
                  </button>
                  <button @click="getRequests" class="btn btn-primary btn-sm pull-right">
                    <span class="glyphicon glyphicon-ok"></span> Aplicar Filtros
                  </button>
                  <span class="clearfix"></span>
                </div>
              </div>
            </div>
          </div>
          <div v-if="loading">
            <loader></loader>
          </div>
          <div v-else>
            <div class="row">
              <div class="col-sm-1">
                <select class="input-sm" v-model="perPage" @change="getRequests">
                  <option :value="5">5</option>
                  <option :value="10">10</option>
                  <option :value="15">15</option>
                </select>
              </div>
              <!-- <div class="col-sm-6">
                <multiselect v-model="statusFilter" :multiple="true" label="name" track-by="value" :options="statuses" :showLabels=false placeholder="Selecione uma opção"></multiselect>
              </div> -->
              <div class="col-sm-6">
                <span v-for="status in statuses" :key="status.value" style="margin-left: 10px;">
                  <input @change="getRequests" type="checkbox" :id="status.value" :value="status.value" v-model="statusFilter">
                  <span :for="status.value">{{status.name}}</span>
                </span>
              </div>
              <div class="col-sm-4">
                <b-form-input v-model="filter" @keyup.enter="getRequests" placeholder="Digite e pressione Enter" class="input-sm"></b-form-input>
              </div>          
            </div>
            <b-table v-if="requests.length > 0" id="user-requests" :items="requests" :fields="requestsfields" striped hover>
              <span slot="icon" slot-scope="item">
                  <span class="glyphicon glyphicon-file"> </span>
              </span>
              <span slot="reqType" slot-scope="item">
                  {{item.value.get('name')}}
              </span>
              <span slot="workflow" slot-scope="item">
                  {{item.value.get('name')}}
              </span>
              <template slot="currentStep" slot-scope="item">
                  {{item.value.get('name')}}
              </template>
              <request-status slot="status" slot-scope="item" :status="item.value">
              </request-status>
              <router-link slot="options" slot-scope="item"
                            :to="{name: 'RequestDetail', params: {id: item.item.objectId}}" 
                class="btn btn-primary btn-xs">
                <span class="glyphicon glyphicon-search"></span> Ver
              </router-link>
            </b-table>
            <div v-else style="padding: 20px">
              <div class="alert alert-info">
                Nenhuma requisição. <span v-if="filter">(Tente remover o filtro e listar novamente)</span>
              </div>
            </div>
            <b-pagination size="sm" :total-rows="count" :per-page="perPage" v-model="currentPage" @input="getRequests"/>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  Parse,
  miniToastr
} from '../Global'
import Loader from './util/Loader'
import RequestStatus from './util/RequestStatus'
import Multiselect from 'vue-multiselect'
import DynamicFormField from './util/DynamicFormField'
import { handleParseError } from './util/ErrorHandling'
let self = null
var Workflow = Parse.Object.extend('Workflow')
var RequestType = Parse.Object.extend('RequestType')
var FormField = Parse.Object.extend('FormField')

export default {
  components: {
    Loader,
    RequestStatus,
    DynamicFormField,
    Multiselect
  },
  data () {
    return {
      loading: false,
      requests: [],
      count: 0,
      requestsfields: {
        icon: { label: '' },
        objectId: { label: 'Identificador' },
        reqType: { label: 'Tipo', sortable: true },
        workflow: { label: 'Workflow', sortable: true },
        currentStep: { label: 'Passo', sortable: true },
        status: { label: 'Status', sortable: true },
        createdAtFmt: {label: 'Data de Abertura', sortable: true},
        options: {label: 'Opções'}
      },
      statusFilter: [],
      statuses: [{name: 'Em análise', value: 'processing'}, {name: 'Concluído', value: 'grant'}, {name: 'Cancelado', value: 'deny'}],
      currentPage: 1,
      perPage: 10,
      workflow: {},
      filter: null,
      fieldFilters: [],
      formFields: []
    }
  },
  mounted () {
    self = this
    self.statusFilter = self.statuses.map(s => s.value)
    this.init()
  },
  methods: {
    init () {
      self.loading = true
      let workflowId = self.$route.params.id
      let queryWorkflow = new Parse.Query(Workflow)
      queryWorkflow.descending('createdAt')
      queryWorkflow.get(workflowId).then(workflow => {
        self.workflow = workflow.toJSON()
        let reqType = new RequestType()
        reqType.id = self.workflow.reqType.objectId
        let queryReqType = new Parse.Query(FormField)
        queryReqType.ascending('order')
        queryReqType.notContainedIn('type', ['separator', 'file', 'document'])
        queryReqType.equalTo('reqType', reqType)
        queryReqType.limit(1000)
        return queryReqType.find()
      }).then(results => {
        self.formFields = results.map(r => r.toJSON())
        return self.getRequests()
      }).fail(error => {
        self.loading = false
        handleParseError(self, error)
      })
    },
    getRequests () {
      let valid = true
      self.fieldFilters.forEach(filter => {
        let type = filter.field.type
        let value = filter.field.value
        let dateValue = filter.field.dateValue
        let dateInvalid = type === 'date' && !dateValue
        let selectInvalid = type === 'select' && !value
        let othersInvalid = !value || (typeof (value) === 'string' && !value.trim())
        if (dateInvalid || selectInvalid || othersInvalid) {
          valid = false
        }
      })
      if (!valid) {
        miniToastr.warn('Preencha todos os campos do filtro.')
        return
      }
      self.loading = true
      let params = {
        currentPage: self.currentPage,
        perPage: self.perPage,
        filter: self.filter,
        workflowId: self.$route.params.id,
        fieldFilters: self.fieldFilters,
        statusFilter: self.statusFilter
      }
      return Parse.Cloud.run('workflowRequests', params).then((results) => {
        self.requests = results.requests.map(r => {
          if (r.createdAt) {
            let dtFormat = new Date(r.createdAt)
            r.createdAtFmt = dtFormat.toLocaleString('pt-BR')
          }
          return r
        })
        self.count = results.total
        self.loading = false
      }).fail(error => {
        self.loading = false
        handleParseError(self, error)
      })
    },
    addFilterField () {
      self.fieldFilters.push({field: JSON.parse(JSON.stringify(self.formFields[0])), operator: '='})
    },
    removeFilter (index) {
      self.fieldFilters.splice(index, 1)
    },
    downloadWorkflowRequests () {
      let self = this
      self.loading = true
      let params = {
        currentPage: self.currentPage,
        perPage: self.perPage,
        filter: self.filter,
        workflowId: self.$route.params.id,
        fieldFilters: self.fieldFilters,
        statusFilter: self.statusFilter
      }
      Parse.Cloud.run('workflowRequestsXlsReport', params).then(data => {
        self.loading = false
        let buffer = new Buffer(data, 'base64')
        let blob = new Blob([new Uint8Array(buffer)], { type: 'application/vnd.ms-excel' })
        let url = window.URL.createObjectURL(blob)
        let a = document.createElement('a')
        document.body.appendChild(a)
        a.style = 'display: none'
        a.href = url
        a.download = 'requests.xlsx'
        a.click()
        window.URL.revokeObjectURL(url)
      }).fail(error => {
        self.loading = false
        handleParseError(self, error)
      })
    }
  }
}
</script>

<style scoped>
.tab {
  cursor: pointer;
}
.tab-content {
  padding: 20px;
  border-style: solid;
  border-color: #ddd;
  border-width: 0px 1px 1px 1px;
}
</style>



// WEBPACK FOOTER //
// WorkflowRequests.vue?44eb583d